import { compact, flow, map, prop, uniq } from 'lodash/fp'

import { OrganizationEvent, OrganizationEventType } from './types'

export const getOrganizationEventTypes = (): OrganizationEventType[] => Object.values(OrganizationEventType)

export const getOrganizationEventLabel = (type: string | OrganizationEventType) =>
  ({
    [OrganizationEventType.adminOrganizationRelease]: 'Admin organization release',
    [OrganizationEventType.automaticOrganizationRelease]: 'Automatic organization release',
    [OrganizationEventType.networkManagerOrganizationRelease]: 'Network manager organization release',
    [OrganizationEventType.roundClosed]: 'Round closed',
    [OrganizationEventType.communicateRoundClosed]: 'Communicate round closed',
    [OrganizationEventType.organizationMatchmakingRelaunch]: 'Organization matchmaking relaunch',
    [OrganizationEventType.contactAttempt]: 'Contact attempt',
    [OrganizationEventType.unableToReachCompany]: 'Unable to reach company',
    [OrganizationEventType.currentlyNotFundraising]: 'Currently not fundraising',
    [OrganizationEventType.notInterestedInOurService]: 'Not interested',
  }[type] || 'Unknown type! :(')

export const getUniqueTypes = (organizationEvents: OrganizationEvent[]): OrganizationEventType[] =>
  flow(map(prop('type')), uniq, compact)(organizationEvents)
